<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
        $t("statistics.lblTopicFeedback")
      }}</span>
      <v-spacer></v-spacer>

      <v-tooltip
        bottom
        v-if="$security.checkUserAccess('ViewMeetingStatistics')"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('ViewMeetingStatistics')"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="primaryDark"
            @click="onBack"
          >
            {{ $t("Back") }}
          </a-btn>
        </template>
        <span>{{ $t("Back") }}</span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="$security.checkUserAccess('ViewMeetingStatistics')"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('ViewMeetingStatistics')"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="primaryDark"
            @click="openFilterDialog"
          >
            {{ $t("lblFilter") }}
          </a-btn>
        </template>
        <span>{{ $t("lblFilter") }}</span>
      </v-tooltip>
    </template>
    <template v-slot:page-content>
      <v-card tile flat style="width: 100%" color="Neutral">
        <v-card-text v-if="isDataLoading" style="padding: 0 0 16px 12px">
          <v-skeleton-loader
            v-bind="attrs"
            type="card-heading"
          ></v-skeleton-loader>
          <v-skeleton-loader v-bind="attrs" type="image"></v-skeleton-loader>
        </v-card-text>
        <v-card-text v-else style="padding: 0 0 16px 12px">
          <!-- <v-row no-gutters class="pl-0 mb-2">
            <span class="text-h6 font-weight-normal ml-3 full-width page-header"
              >{{ meetingName }}
            </span>
          </v-row> -->
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
              <topic-feedback-filter-details
                v-if="filterDetails"
                :filterDetails="filterDetails"
              >
              </topic-feedback-filter-details>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="mt-1">
              <topic-feedback-table :feedbacks="feedbacks">
              </topic-feedback-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <feedback-meeting-filter
        v-if="isOpenFilterDialog"
        v-model="isOpenFilterDialog"
        @feedbackFilterPayload="onFeedbackFilter"
      >
      </feedback-meeting-filter>
    </template>
  </page-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FeedbackMeetingFilter from "./FeedbackMeetingFilter.vue";
import TopicFeedbackFilterDetails from "./TopicFeedbackFilterDetails.vue";
import TopicFeedbackTable from "./TopicFeedbackTable.vue";
export default {
  components: {
    TopicFeedbackTable,
    TopicFeedbackFilterDetails,
    FeedbackMeetingFilter,
  },
  name: "TopicFeedbackAnalysis",
  data() {
    return {
      isOpenFilterDialog: false,
      meetingName: "",
      feedbacks: [],
      isDataLoading: false,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      filterDetails: null,
      deletedUserIds: [],
    };
  },
  async mounted() {
    try {
      this.isDataLoading = true;
      const id = this.$route.params.id;
      const filterStoragePrams = sessionStorage.getItem(
        "TopicFeedbackFilterInputs"
      );
      const waitForUserList = async () => {
        return new Promise((resolve) => {
          const checkUserList = () => {
            if (this.userList.length) {
              resolve();
            } else {
              setTimeout(checkUserList, 100);
            }
          };
          checkUserList();
        });
      };

      await waitForUserList();

      if (filterStoragePrams) {
        const filterPrams = JSON.parse(filterStoragePrams);
        this.filterDetails = filterPrams;
        const result = await this.getTopicFeedbacks(filterPrams);
        this.meetingName = result.meeting_name;
        this.feedbacks = groupFeedbackByTopic(result);

        if (this.feedbacks.length) {
          this.feedbacks.map(async (item) => {
            this.getAllDeletedUsersIds(item.feedbacks);
          });
          const deletedIds = [...new Set(this.deletedUserIds)];
          await this.getDeletedUsersList(deletedIds);
        }
      }
      this.isDataLoading = false;
    } catch (error) {
      this.isDataLoading = false;
    }
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
    }),
  },
  methods: {
    ...mapActions({
      getTopicFeedbacks: "admin/getTopicFeedbacks",
      getDeletedUsersList: "meeting/getDeletedUsersListTemp",
    }),
    groupFeedbackByTopic,
    openFilterDialog,
    onFeedbackFilter,
    onBack,
    getAllDeletedUsersIds,
  },
};

async function getAllDeletedUsersIds(users) {
  let localUserList = [...this.userList];
  const userWithIdExists = (id) => localUserList.some((obj) => obj.id === id);
  const unmatchedObjects = users.filter(
    (obj) => !userWithIdExists(obj.user_id)
  );
  const unmatchedIds = unmatchedObjects.map((obj) => obj.user_id);
  if (unmatchedIds.length) {
    this.deletedUserIds = this.deletedUserIds.concat(unmatchedIds);
  }
}

function onBack() {
  this.$router.push({ path: "/statistics&analysis" });
}

async function onFeedbackFilter(filterPrams) {
  this.filterDetails = filterPrams;
  const result = await this.getTopicFeedbacks(filterPrams);
  this.feedbacks = groupFeedbackByTopic(result);
  if (this.feedbacks.length) {
    this.feedbacks.map(async (item) => {
      this.getAllDeletedUsersIds(item.feedbacks);
    });
    const deletedIds = [...new Set(this.deletedUserIds)];
    await this.getDeletedUsersList(deletedIds);
  }
}

function openFilterDialog() {
  this.isOpenFilterDialog = true;
}

function groupFeedbackByTopic(data) {
  const groupedData = [];
  const topicMap = new Map();

  data.forEach((item) => {
    const key = `${item.meeting_id}_${item.topic_id}`;
    if (!topicMap.has(key)) {
      topicMap.set(key, {
        id: item.id,
        topic_id: item.topic_id,
        topic_name: item.topic_name,
        agenda_name: item.agenda_name,
        agenda_category: item.agenda_category,
        topic_category: item.topic_category,
        meeting_id: item.meeting_id,
        meeting_name: item.meeting_name,
        start_date: item.scheduletStartTimeInUTC,
        feedbacks: new Map(), // Use Map to ensure uniqueness by item.id
        totalRating: 0,
        count: 0,
      });
      groupedData.push(topicMap.get(key));
    }

    const topic = topicMap.get(key);
    if (!topic.feedbacks.has(item.id)) {
      topic.feedbacks.set(item.id, item); // Avoid duplicates
      topic.totalRating += item.rating;
      topic.count++;
    }
  });

  return groupedData.map((topic) => ({
    id: topic.id,
    topic_id: topic.topic_id,
    topic_name: topic.topic_name,
    agenda_name: topic.agenda_name,
    agenda_category: topic.agenda_category,
    topic_category: topic.topic_category,
    meeting_id: topic.meeting_id,
    meeting_name: topic.meeting_name,
    start_date: topic.start_date,
    feedbacks: Array.from(topic.feedbacks.values()), // Convert Map to array
    average_rating: topic.count ? topic.totalRating / topic.count : 0,
  }));
}
</script>

<style scoped>
.v-list-item__title {
  white-space: normal;
  line-height: 1.3;
}

.v-list-item__subtitle {
  line-height: 1.5;
}
</style>